var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 4.609a7.391 7.391 0 1 0 0 14.782A7.391 7.391 0 0 0 12 4.61M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m8.696-3.478c0-.72.584-1.305 1.304-1.305h.009a1.304 1.304 0 1 1 0 2.61H12c-.72 0-1.304-.585-1.304-1.305M12 10.696c.72 0 1.304.584 1.304 1.304v3.478a1.304 1.304 0 1 1-2.608 0V12c0-.72.584-1.304 1.304-1.304",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;